<template>
  <div
    v-if="character"
    class="text-center summary-section"
  >
    <p class="bb-hdg mt-2 mb-3">Chars</p>
    <div class="row mb-2"></div>
    <div class="row mt-2 mb-2">
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center"
            :value="character.str_cur"
            id="str_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="str_cur"
            >Str</label
          >
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center"
            :value="character.con_cur"
            id="con_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="con_cur"
            >Con</label
          >
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center"
            :value="character.dex_cur"
            id="dex_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="dex_cur"
            >Dex</label
          >
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center"
            :value="character.siz_cur"
            id="siz_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="siz_cur"
            >Siz</label
          >
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center"
            :value="character.int_cur"
            id="int_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="int_cur"
            >Int</label
          >
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center"
            :value="character.pow_cur"
            id="pow_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="pow_cur"
            >Pow</label
          >
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center"
            :value="character.cha_cur"
            id="cha_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="cha_cur"
            >Cha</label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SheetSummaryChars',
  props: {
    character: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.summary-section {
  min-width: 0;
  width: 100%;
}
</style>
